import { useSessionId } from '@moonpig/web-core-utils'
import { VariationType } from '@eppo/js-client-sdk-common'
import { logger } from '@moonpig/web-core-monitoring'
import {
  useEppoClient,
  useEppoCustomerId,
  useEppoExperimentOverrides,
} from '@moonpig/web-core-utils/src/eppoContext/EppoContext'
import { tryResolveEppoSubjectKey } from '../../shared/resolveEppoSubjectKey'

export const useAllEppoExperiments = () => {
  const eppoClient = useEppoClient()
  const customerId = useEppoCustomerId()

  const overrides = useEppoExperimentOverrides()
  const { sessionId } = useSessionId()

  if (!eppoClient) {
    logger.fixToday('Error calling useAllEppoExperiments: eppoClient is null')
    return {}
  }

  const allFlags = eppoClient.getFlagKeys()
  const flagConfigurations = eppoClient.getFlagConfigurations()

  const experiments: Record<string, string> = {}

  allFlags.forEach(flagKey => {
    if (overrides?.[flagKey]) {
      experiments[flagKey] = overrides[flagKey]
      return
    }

    const flagConfiguration = flagConfigurations[flagKey]

    const eppoSubjectKey = flagConfiguration
      ? tryResolveEppoSubjectKey(flagConfiguration, sessionId, customerId)
      : sessionId

    if (!eppoSubjectKey) return

    const { variationType } = flagConfiguration
    switch (variationType) {
      case VariationType.STRING:
        experiments[flagKey] = eppoClient.getStringAssignment(
          flagKey,
          eppoSubjectKey,
          { shouldLog: false },
          'control',
        )
        break
      case VariationType.BOOLEAN:
        experiments[flagKey] = eppoClient
          .getBooleanAssignment(
            flagKey,
            eppoSubjectKey,
            { shouldLog: false },
            false,
          )
          .toString()
        break
      case VariationType.INTEGER:
        experiments[flagKey] = eppoClient
          .getIntegerAssignment(
            flagKey,
            eppoSubjectKey,
            { shouldLog: false },
            0,
          )
          .toString()
        break
    }
  })

  return experiments
}
